let inflightRequest: Promise<string | undefined> | null = null;

export const getAuthToken = async (): Promise<string | undefined> => {
    if (inflightRequest) return inflightRequest;

    inflightRequest = (async () => {
        try {
            const response = await fetch('/oauth2/auth');
            return response.headers.get('x-auth-request-access-token') ?? undefined;
        } catch {
            return undefined;
        } finally {
            inflightRequest = null;
        }
    })();

    return inflightRequest;
};
